import { motion } from "framer-motion";
import { WHY } from "../../lib/site";

export const WhyChoose = () => (
  <section id="why" className="relative bg-[#0b192c] text-white py-24 md:py-32 overflow-hidden" data-testid="why-choose">
    <div className="noise-overlay" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-8">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#ef233c]">Why UPV Services</span>
          <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
            The trusted name in expedited travel documents.
          </h2>
          <p className="mt-6 text-white/70 leading-relaxed">
            A privately owned courier company helping US citizens and permanent residents prepare and submit the documentation they need for business and personal travel. We are not a government agency and are not affiliated with or endorsed by the U.S. Department of State or any government entity.
          </p>
        </div>

        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-white/10 rounded-2xl overflow-hidden">
          {WHY.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="relative bg-[#0b192c] p-8 md:p-10 hover:bg-[#1a2a40] transition-colors duration-300"
                data-testid={`why-item-${i}`}
              >
                <span className="font-display font-black text-6xl text-white/10 absolute top-6 right-8 select-none">{item.n}</span>
                <Icon className="w-8 h-8 text-[#ef233c]" />
                <h3 className="mt-6 font-display font-bold text-xl">{item.title}</h3>
                <p className="mt-3 text-white/65 leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
